import { apiInstance } from "../config/api";

export const authService = {
  async createAccount(payload: {
    phoneNumber: string;
    userDetails: {
      fullName: string;
      email?: string;
      password: string;
    };
  }) {
    const response = await apiInstance.post("/profiler-account", payload);
    return response.data;
  },

  async login(payload: { phoneNumber: string; password: string }) {
    const response = await apiInstance.post("/profiler-account/login", payload);
    return response.data;
  },
};